import { useState } from "react";
import useAuth from "../../hooks/useAuth";
import { Link, useLocation, Navigate, useNavigate } from "react-router-dom";
import { Row, Container, Col, Form, Button, InputGroup } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import axios from "../../api/axios";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUnlockKeyhole,
  faRightToBracket,
} from "@fortawesome/free-solid-svg-icons";

function Login() {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/vendors";
  const [user, setUser] = useState("");
  const [pwd, setPwd] = useState("");

  const handleSubmit = async (user, pwd, e) => {
    e.preventDefault();

    let valid = true;

    if (user.length < 1) {
      toast.error("Vpisati morate uporabniško ime / e-naslov");
      valid = false;
    }

    if (pwd.length < 1) {
      toast.error("Vpisati morate geslo");
      valid = false;
    }
    if (valid) {
      try {
        const response = await axios.post(
          "/login",
          {
            user: user,
            pwd: pwd,
          },
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
        const accessToken = response?.data?.accessToken;
        const roles = response?.data?.roles;

        setAuth({ user, pwd, roles, accessToken });
        navigate(from, { replace: true });
      } catch (err) {
        console.log(err);
        toast.error(err.message);
      }
    }
  };

  return (
    <div className="container-fluid prcLoginWrap">
      <Container>
        <Row>
          <Col
            xs={6}
            md={{ span: 4, offset: 4 }}
            sm={{ span: 8, offset: 2 }}
            className="prcLogin"
          >
            <Form noValidate onSubmit={(e) => handleSubmit(user, pwd, e)}>
              <Form.Label htmlFor="formTitle" className="prcLoginHeader">
                <h4>Prijava v admin konzolo</h4>
              </Form.Label>
              <div className="prcLoginEmail">
                <Form.Group className="has-danger form-group">
                  <Form.Label className="sr-only" htmlFor="userInput">
                    E-poštni naslov
                  </Form.Label>
                  <InputGroup className="mb-2 mr-sm-2 mb-sm-0">
                    <InputGroup.Text id="basic-addon2">@</InputGroup.Text>
                    <Form.Control
                      type="email"
                      id="userInput"
                      placeholder="E-poštni naslov"
                      onChange={(e) => setUser(e.target.value)}
                      value={user}
                    />
                  </InputGroup>
                </Form.Group>
              </div>
              <div className="prcLoginPass">
                <Form.Group className="has-danger form-group">
                  <Form.Label className="sr-only" htmlFor="password">
                    Geslo
                  </Form.Label>
                  <InputGroup className="mb-2 mr-sm-2 mb-sm-0">
                    <InputGroup.Text id="basic-addon2">
                      <FontAwesomeIcon icon={faUnlockKeyhole} />
                    </InputGroup.Text>
                    <Form.Control
                      type="password"
                      id="pwdInput"
                      placeholder="Geslo"
                      onChange={(e) => setPwd(e.target.value)}
                      value={pwd}
                    />
                  </InputGroup>
                </Form.Group>
              </div>
              <div className="prcLoginSubmit text-center">
                <Button type="submit" variant="success">
                  <FontAwesomeIcon icon={faRightToBracket} /> Prijava
                </Button>{" "}
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
      <ToastContainer autoClose={10000} position="top-right" theme="light" />
    </div>
  );
}

export default Login;
